import { render, staticRenderFns } from "./CompanySettingSideMenu.vue?vue&type=template&id=7005a5db&scoped=true"
import script from "./CompanySettingSideMenu.vue?vue&type=script&lang=js"
export * from "./CompanySettingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingSideMenu.vue?vue&type=style&index=0&id=7005a5db&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005a5db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7005a5db')) {
      api.createRecord('7005a5db', component.options)
    } else {
      api.reload('7005a5db', component.options)
    }
    module.hot.accept("./CompanySettingSideMenu.vue?vue&type=template&id=7005a5db&scoped=true", function () {
      api.rerender('7005a5db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanySettingSideMenu.vue"
export default component.exports